import { selection, timePeriods, raceTypes } from '../../utils/filter';

const raceTypeFactory = (country, type) => ({
    title: 'race type',
    options: selection.setSelected(raceTypes.human, `${country}/${type}`),
});

export const timePeriodsFactory = (country, raceType) => {
    const currentYear = timePeriods.getCurrentSeasonEndYear(raceType, country);
    const options = timePeriods.getPeriods(currentYear, 1987, raceType)
        .map(timePeriods.removeEndYear);

    return {
        title: 'time period',
        options: selection.setSelected(options, options[0].value),
        createdBy: { raceType },
    };
};

const categoriesFactory = (country, type) => (country && type ? {
    raceType: raceTypeFactory(country, type),
    timePeriod: timePeriodsFactory(country, type),
} : null);

export default categoriesFactory;



// WEBPACK FOOTER //
// ./src/js/human/horses/categories.js